import React from 'react';
import PropTypes from 'prop-types';

import {Box, Paper, Typography} from 'views/components';
import {InfoOutlined} from 'views/icons';
import {Translate} from 'views/module';

const ExpectedCostCard = (props) => {
  const {weeklyAmount, hoursPerWeek} = props;

  const parsedWeeklyAmount = React.useMemo(() => {
    if (typeof weeklyAmount === 'number') {
      return weeklyAmount;
    }

    if (typeof weeklyAmount === 'string') {
      const normalizedAmount = parseInt(weeklyAmount, 10);
      return isNaN(normalizedAmount) ? 0 : normalizedAmount;
    }

    return 0;
  }, [weeklyAmount]);

  const isZeroAmount = parsedWeeklyAmount === 0;

  const formatWeeklyAmount = (amount) => {
    if (!amount) return '0';
    const num = typeof amount === 'string' ? parseInt(amount, 10) : amount;
    if (isNaN(num)) return '0';
    return num.toLocaleString();
  };

  return (
    <Paper
      sx={{
        p: '32px',
        borderRadius: '24px',
        boxShadow: 'none',
      }}
    >
      <Box sx={{gap: '12px', display: 'flex', flexDirection: 'column'}}>
        <Typography sx={{fontSize: '24px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
          <Translate expression={'schedulestep.ExpectedCostCard.Title'} />
        </Typography>

        {
          isZeroAmount && (
            <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#3C3C3C', lineHeight: '150%'}}>
              <Translate expression={'schedulestep.ExpectedCostCard.NoEstimateMessage'} />
            </Typography>
          )
        }
        {
          !isZeroAmount && (
            <React.Fragment>
              <Typography sx={{fontSize: '32px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
                <Translate
                  expression={'schedulestep.ExpectedCostCard.FromWeeklyAmount'}
                  substitute={{weeklyAmount: formatWeeklyAmount(parsedWeeklyAmount), monthlyAmount: parsedWeeklyAmount * 4}}
                />
              </Typography>

              <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
                <Translate expression={'schedulestep.ExpectedCostCard.BasedOn'} />{' '}
                <span style={{fontWeight: 600, color: '#2D2925'}}>
                  <Translate
                    expression={'schedulestep.ExpectedCostCard.HoursPerWeek'}
                    substitute={{hoursPerWeek: hoursPerWeek || '0'}}
                  />
                </span>
                {' '}
                <Translate expression={'schedulestep.ExpectedCostCard.And'} />{' '}
                <span style={{fontWeight: 600, color: '#2D2925'}}>
                  <Translate expression={'schedulestep.ExpectedCostCard.QuarterlyBooking'} />
                </span>
              </Typography>
            </React.Fragment>
          )
        }

        <Box
          sx={{
            p: '24px',
            borderRadius: '16px',
            backgroundColor: '#DA795514',
          }}
        >
          <Box sx={{display: 'flex', alignItems: 'center', gap: '8px', mb: '12px'}}>
            <InfoOutlined sx={{fontSize: 24, color: '#DA7955'}} />
            <Typography sx={{fontSize: '16px', fontWeight: 590, color: '#2D2925', lineHeight: '150%'}}>
              <Translate expression={'schedulestep.Common.PleaseNote'} />
            </Typography>
          </Box>
          <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925', lineHeight: '150%'}}>
            <Translate expression={'schedulestep.ExpectedCostCard.FinalQuoteNotice'} />
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

ExpectedCostCard.propTypes = {
  weeklyAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hoursPerWeek: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default React.memo(ExpectedCostCard);
